// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Button_Btn__2WytR","Solid":"Button_Solid__3pdej","Outline":"Button_Outline__3QhQH","Link":"Button_Link__3vCy8"};